import { InjectionToken } from '@angular/core';
import type { ElementRef, Signal, OutputEmitterRef } from '@angular/core';

export interface SplitButtonLike<T> {
  readonly selectChange: OutputEmitterRef<boolean>;
  value(): T | undefined;
  setButtonId(id: number): void;
  getButtonId(): number | undefined;
  setParentId(parentId: string): void;
  setActive(active: boolean): void;
  isActive(): boolean;
  getValue(): T | undefined;
  readonly el: ElementRef;
}

export interface SplitButtonsRegistration<T> {
  buttonList: Signal<ReadonlyArray<SplitButtonLike<T>>>;
  registerButton(button: SplitButtonLike<T>): void;
  unregisterButton(button: SplitButtonLike<T>): void;
}

export const SPLIT_BUTTONS_REGISTRATION = new InjectionToken<SplitButtonsRegistration<unknown>>('SplitButtonsRegistration');
